import React from "react";
import FormMessage from "../FormMessage/FormMessage";
import Markdown from "../../components/Markdown";

const RejectReasons = ({ reasons }) => {
  if (reasons.length == 0) {
    return null;
  }

  return (
    <div className="teaser-form__comments">
      <FormMessage color="warn">
        {reasons.map(reason => (
          <p key={reason.id}>
            {reason.number} <Markdown text={reason.message} />
          </p>
        ))}
      </FormMessage>
    </div>
  );
};

RejectReasons.defaultProps = {
  reasons: []
};

export default RejectReasons;
